/*
 * @Description:
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: Please set LastEditors
 */
//入口
// import fields from './fields';
import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import { csoCustomerOrder } from '@/api/ajax';

let example = new TableRenderClass({ fields, search });

// 页面入口
const homePagePart = example.createPart({
  name: '订单详情',
  search: ['projectName', 'monthrange', 'xiangmucanyuren', 'shoujihao'],
  list: csoCustomerOrder.listAllPeople,
  requestNow: true,
  fields: [
    'xiangmucanyuren',
    'shoujihao',
    'shoukuanzhanghao',
    'shoukuanfangshi',
    'xiangmumingcheng',
    'renwuyuedu',
    'gongyingshang',
    'shijiwanchengrenwuliang',
    'zhongduanjiesuandanjia',
    'zhongduanjiesuanjine',
    'fuwufeilv',
    'jiesuanzongjia',
    'zhifuzhuangtai',
    'daozhangshijian'
  ]
});

/*主页面入口*/
export const main = [{ name: '订单详情', childMenu: [homePagePart] }];

// 修改支付人|列表
export const listNoPayOrderPeopleByOrderId = [
  {
    name: '修改支付人|列表',
    childMenu: [
      example.createPart({
        name: '修改支付人|列表', // 修改支付人
        search: [
          'xiangmumingcheng',
          'createDate',
          'xiangmucanyuren',
          'shoujihao'
        ],
        list: csoCustomerOrder.listNoPayOrderPeopleByOrderId,
        requestNow: true,
        fields: [
          {
            type: 'selection',
            width: '55',
            selectable(row) {
              // 关闭支付、线下完成支付的订单
              const isCloseOrrgType =
                !!+row.closeOrRgType && [1, 2].includes(+row.closeOrRgStatus);
              if (isCloseOrrgType) return false;

              return row.revokeStatus !== 2;
            }
          },
          'index',
          'orderNo',
          'xiangmucanyuren',
          'shoujihao',
          'shoukuanzhanghao',
          'xiangmumingcheng',
          'createDate',
          'gongyingshang',
          'shijiwanchengrenwuliang',
          'zhongduanjiesuandanjia',
          'zhongduanjiesuanjine',
          'fuwufeilv',
          'jiesuanzongjia'
          // 'zhifuzhuangtai',
          // 'daozhangshijian'
        ]
      })
    ]
  }
];
